import { Post } from './../../models/ghost/Post';
import { ViewController } from 'ionic-angular';
import { Component } from '@angular/core';

/**
 * Generated class for the GlossaryDefinitionComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'glossary-definition',
  templateUrl: 'glossary-definition.html'
})
export class GlossaryDefinitionComponent {

  post: Post;
  content: string;
  title: string = "Definition";
  class: string = '';
  constructor(private viewCtrl: ViewController) {
    this.post = this.viewCtrl.getNavParams().get('post');
    this.class = this.viewCtrl.getNavParams().get('class');
    const title = this.viewCtrl.getNavParams().get('title');
    if(title) this.title = title;

    if(this.post.html){
      this.content = this.post.html;
    }else{
      this.content = "oops";
    }
  }

  dismiss(){
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/components/glossary-definition/glossary-definition.ts